<template>
  <b-card :header="caption">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :currentPage="currentPage" :perPage="perPage">
      <template slot="id" slot-scope="data">
        <b-badge :variant="getBadge(data.item.id)">{{data.item.id}}</b-badge>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Siguiente" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>
<script>
const defaults = {
  currentPage: 1,
  perPage: 5,
  totalRows: 0
}

export default {
  name: 'c-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array
    },
    fields: {
      type: Array
    }
  },
  data: () => {
    return defaults
  },
  methods: {
    goItem (id) {
      console.log(id)
    },
    getRowCount (items) {
      return items.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/Table.vue